import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../store';
import { closeGameSocket, getGameSocket, initializeGameSocket } from './gameSocket';

const devMode = import.meta.env.VITE_DEVELOP_MODE;

export const useGameSocket = (): void => {
  const dispatch = useAppDispatch();
  const hasInitialized = useRef(false);

  const isDevMode = devMode === 'true';

  useEffect(() => {
    if (!isDevMode) return;

    // Проверяем, есть ли уже активное подключение
    const existingSocket = getGameSocket();
    if (existingSocket?.connected) {
      console.log('Socket already connected, skipping initialization');
      return;
    }

    // Защита от многократного вызова
    if (hasInitialized.current) {
      console.log('useGameSocket already initialized, skipping');
      return;
    }

    console.log('Initializing game socket...');
    hasInitialized.current = true;

    initializeGameSocket(dispatch).catch(console.error);

    return () => {
      if (isDevMode) return;

      closeGameSocket();
      hasInitialized.current = false;
    };
  }, [dispatch]);

  // Эффект для обработки HMR
  useEffect(() => {
    if (!isDevMode) return;

    // При HMR сбрасываем флаг инициализации
    if (import.meta.hot) {
      import.meta.hot.accept(() => {
        console.log('HMR detected, resetting initialization flag');
        hasInitialized.current = false;
      });
    }
  }, []);
};
